// extracted by mini-css-extract-plugin
export default {"ladderPrice":"ladderPrice__EWx3s"};